// Products.jsx
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import Footer from "../footer/footer";
import CustomNavbar from "./productnavbar";
import Bar1 from "../../../components/navigationbar/navigationbar1";
import logo from "../../../Assets/image/logo.png";
import { Spinner, Input } from "@nextui-org/react";
import { BASEURL } from "../../../constant/constant";
import "./Productsa.css";

function Products() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [allProducts, setAllProducts] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const dropdownRef = useRef(null);
  const hasFetched = useRef(false);

  const fetchCategories = async () => {
    const response = await fetch(`${BASEURL}/api/product/getCategory`, {
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json();
    if (data.categories) {
      return data.categories.map((item) => ({
        id: item.category.category_id,
        slug: item.category.category_slug,
        name: item.category.category_name,
        img: `${BASEURL}${item.category.img_url}`,
        route: `/category/${item.category.category_id}`,
      }));
    }
    return [];
  };

  useEffect(() => {
    if (hasFetched.current) return;           // Prevent second StrictMode run
    fetchCategories()
      .then((mappedCategories) => {
        setCategories(mappedCategories);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      })
      .finally(() => setLoading(false));
    hasFetched.current = true;               // Mark fetch as done
  }, []);

  const Search_Product = async (query) => {
    if (!query.trim()) {
      setFilteredResults([]);
      return;
    }

    try {
      const response = await fetch(
        `${BASEURL}/api/product/serachProduct?term=${query}`
      );

      if (!response.ok) {
        throw new Error("Server is not responding");
      }

      const result = await response.json();
      console.log("Full API Response:", result);

      if (result.data && Array.isArray(result.data)) {
        const extractedProducts = result.data.flatMap((item) => {
          console.log("Item:", item);

          const category = item.category;
          console.log("Category:", category);

          const categoryData = category?.category_data;
          console.log("Category Data:", categoryData);

          const product = categoryData?.products;
          console.log("Product:", product);

          if (!category || !categoryData || !product) return [];

          const productItemId = product?.product_item_id;
          console.log("Product Item ID:", productItemId);

          return {
            ...product,
            slug: item.slug,
            sub_category_slug: categoryData.sub_category_slug,
            product_item_id: productItemId,
          };
        });

        setFilteredResults(extractedProducts);
      } else {
        setFilteredResults([]);
      }
    } catch (error) {
      console.error("API is not responding", error);
      setFilteredResults([]);
    }
  };

  const handleSuggestionClick = (item) => {
    setSearchQuery(item.product_description);
    setFilteredResults([]);

    const categoryId = item.category_id || item.category?.category_id;
    const subCategoryId =
      item.sub_category_id || item.category?.category_data?.sub_category_id;
    const productItemId = item.product_item_id;
    const productId = item.product_id;

    console.log(
      "This is the product_item_id ============>",
      categoryId,
      subCategoryId,
      productItemId
    );

    // Navigate if needed
    // if (categoryId !== null && subCategoryId !== null && productItemId !== null) {
    //   let isSearchable = true;
    //   navigate(`/productdetails/${categoryId}/${subCategoryId}/${productItemId}/${isSearchable}`);
    // }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    if (!value.trim()) {
      setFilteredResults([]);
      return;
    }

    Search_Product(value);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setFilteredResults([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="products flex flex-col p-2 relative">
      <Helmet>
        <title>
          High-Efficiency Solar Pump Controllers & ATS | Sandip electronics
        </title>
        <meta
          name="description"
          content="Shop industrial-grade 1HP to 10HP Solar Pump Controllers, Automatic Transfer Switches (ATS), and BLDC Motors. High-performance automation solutions by SEA Pune."
        />
        <meta
          name="keywords"
          content="मागेल त्याला सौर कृषी पंप योजना || solar pump controller manufacturer, automatic transfer switch price, BLDC motor controller India, solar submersible pump 5HP, SEA automation products"
        />
        <meta
          property="og:title"
          content="Advanced Automation Products by Sandip electronics  & Automation"
        />
        <meta
          property="og:description"
          content="Explore our catalog of energy-efficient solar controllers, power management switches, and IoT monitoring systems."
        />
        <meta
          property="og:image"
          content="https://seaiot.in/images/product-catalog-banner.jpg"
        />
        <meta property="og:url" content="https://seaiot.in/products" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="App11">
        <div className="mylogo">
          <div className="logo-container">
            <Link to="/" className="cursor-pointer">
              <img src={logo} alt="Logo" />
            </Link>
          </div>
        </div>
        <div className="bar-container">
          <Bar1 />
        </div>
      </div>

      {/* <div className="custom-navbar">
        <CustomNavbar />
      </div> */}

      <div className="relative w-full flex items-center mt-8">
        <div className="w-full max-w-md ml-4 sm:ml-0">
          <Input
            isClearable
            className="productinput w-96 sm:w-96 ml-4"
            placeholder="Search Products"
            value={searchQuery}
            onChange={handleSearchChange}
            onClear={() => {
              setSearchQuery("");
              setFilteredResults([]);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" && filteredResults.length > 0) {
                handleSuggestionClick(filteredResults[0]);
              }
            }}
          />

          {filteredResults.map((item, index) => {
            const slug = item.slug;
            const sub_category_slug = item.sub_category_slug;
            const productItemId = item.product_item_id;

            return (
              <div
                key={index}
                className="p-2 cursor-pointer hover:bg-gray-100 flex items-center"
                onClick={() => {
                  console.log("productItemId====>", productItemId);
                  if (slug !== null && slug !== null) {
                    let isSearchable = true;
                    navigate(
                      `/productdetails/${slug}/${sub_category_slug}`
                    );
                  } else {
                    console.error(
                      "Category, Sub-category, or Product Item ID is missing"
                    );
                  }
                }}
              >
                <img
                  src={`${BASEURL}${item.img_url}`}
                  alt={item.product_name}
                  className="w-10 h-10 rounded mr-3"
                />
                <span>{item.product_description}</span>
                <span>{item.manufacturer}</span>
              </div>
            );
          })}
        </div>
      </div>

      <div className="background-textpa">Product</div>

      {loading ? (
        <div className="flex justify-center items-center h-48">
          <Spinner color="warning" label="Loading..." />
        </div>
      ) : (
        <div className="mb-10">
          {searchQuery.trim() && filteredResults.length === 0 ? (
            <div className="text-center text-gray-500">No products found.</div>
          ) : (
            <div className="grid grid-cols-12 p-2 m-2">
              {categories.map((category) => (
                <div
                  className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3 item-center"
                  key={category.id}
                >
                  <div
                    className="productcard"
                    onClick={() => navigate(`/ProductSubCategory/${category.slug}`
                      , {
                        state: { categoryName: category.name },
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      className="mt-20"
                      src={category.img}
                      alt={category.name}
                      style={{
                        filter:
                          "drop-shadow(5px 5px 10px rgba(0, 0, 0, 0.5))",
                        borderRadius: "8px",
                        height: "300px",
                      }}
                    />
                    <div className="productcardtitle">
                      <h3>{category.name}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      <Footer />
    </div>
  );
}

export default Products;
